import { INBOUND_DB_IMPORT } from 'customer-data-objects/property/ExternalOptionTypes';
import { isExternalOptionsField } from 'customer-data-filters-ui/utils/isExternalOptionsField';
import { getInboundDbImportReferenceResolver } from 'customer-data-filters-ui/utils/getInboundDbImportReferenceResolver';
import { getPropertyResolver } from 'reference-resolvers-lite/utils/getPropertyResolver';
import { useContext, useMemo } from 'react';
import { useStrategy } from './useStrategy';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { TEAM as TeamReferenceObjectType } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { TEAM as TeamExternalOptionType } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
export const useQuickFilterResolverAndOptions = (filterFamily, isOptionsSelectDisabled, property) => {
  const {
    getSpecialOptionsForReferenceType,
    getReferencedObjectType,
    getReferenceResolvers
  } = useStrategy();
  const {
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const referencedObjectType = getReferencedObjectType(filterFamily, {
    field: property
  });
  const resolver = useMemo(() => {
    // TEAM reference fields must use a ReferenceResolver that is compatible
    // with the TeamQuickFilterButton component
    if ((property === null || property === void 0 ? void 0 : property.get('externalOptionsReferenceType')) === TeamExternalOptionType || (property === null || property === void 0 ? void 0 : property.get('referencedObjectType')) === TeamReferenceObjectType) {
      return getReferenceResolvers(filterFamily).get(TeamReferenceObjectType);
    }
    if (isExternalOptionsField(property, filterFamily, getIsUngated)) {
      return getPropertyResolver({
        property: property,
        objectTypeId: filterFamily
      });
    }
    const referenceResolver = getReferenceResolvers(filterFamily).get(referencedObjectType) || null;
    if (typeof referenceResolver === 'function' && referencedObjectType === INBOUND_DB_IMPORT) {
      const inboundDbImportReferenceResolver = getInboundDbImportReferenceResolver(referenceResolver, filterFamily);
      return inboundDbImportReferenceResolver;
    }
    return referenceResolver;
  }, [property, filterFamily, referencedObjectType, getReferenceResolvers, getIsUngated]);
  const specialOptions = useMemo(() => {
    const options = getSpecialOptionsForReferenceType(referencedObjectType, filterFamily);
    return options ? options.toJS() : [];
  }, [filterFamily, getSpecialOptionsForReferenceType, referencedObjectType]);
  const options = useMemo(() => {
    return specialOptions.map(specialOption => ({
      disabled: isOptionsSelectDisabled,
      help: specialOption.description,
      icon: specialOption.icon,
      text: specialOption.label,
      value: specialOption.value
    }));
  }, [isOptionsSelectDisabled, specialOptions]);
  return {
    resolver,
    options
  };
};